













import { Vue, Component } from 'vue-property-decorator'
import { TitleBlockModel } from '../models'
import TitleBlock from '../components/TitleBlock.vue'

@Component({
  components: {
    TitleBlock,
  }
})

export default class BlockHero extends Vue {
  titles: TitleBlockModel = {
    title: 'Станьте<br>самозанятым<br>поставщиком',
    subtitle: 'Откройте новые возможности для своего бизнеса'
  }
  hash: string = 'instructions'

  onBtnClick() {
    if (this.$route.hash.slice(1) === this.hash) {
      this.$router.push({path: '/'}, () => this.$router.push({path: `/#${this.hash}`}))
    } else this.$router.push({path: `/#${this.hash}`})
  }
}
